import React from 'react';

// Pages
import { AppRouter } from '@Pages/AppRouter';

export const App: React.FC = () => {
  return <AppRouter />;
};
